import Vue from 'vue'
import Vuex from 'vuex'
import usercenter from './usercenter'
import roomlive from './roomlive'
Vue.use(Vuex)
export default new Vuex.Store({
    modules:{
        usercenter,
        roomlive
    }
})